import { ReactNode } from "react";
import { ServiceChargeInvoiceBreakdownModel } from "services/api/cplapi/CPLAPI";

export function getDeliveryOption(shouldEmail?: boolean, shouldPrint?: boolean): string {
  const email = shouldEmail === true;
  const print = shouldPrint === true;

  if (email && print) return "Email & Print";
  if (email) return "Email";
  if (print) return "Print";
  return "Neither";
}

export function getDeliveryStatusText(breakdown: ServiceChargeInvoiceBreakdownModel): string {
  const { emailSucceededDate, emailFailedDate, printSucceededDate, printFailedDate } = breakdown;
  const statuses: string[] = [];

  // Email: success overrides failure
  if (emailSucceededDate) {
    statuses.push("Email Completed");
  } else if (emailFailedDate) {
    statuses.push("Email Failed");
  }

  // Print: success overrides failure
  if (printSucceededDate) {
    statuses.push("Print Completed");
  } else if (printFailedDate) {
    statuses.push("Print Failed");
  }

  return statuses.length ? statuses.join(" & ") : "Unknown";
}

export function getDeliveryStatusNode(breakdown: ServiceChargeInvoiceBreakdownModel): ReactNode {
  const { emailSucceededDate, emailFailedDate, printSucceededDate, printFailedDate } = breakdown;
  const statuses: ReactNode[] = [];

  // Email: success overrides failure
  if (emailSucceededDate) {
    statuses.push(<span className="text-success">Email Completed</span>);
  } else if (emailFailedDate) {
    statuses.push(<span className="text-danger">Email Failed</span>);
  }

  // Print: success overrides failure
  if (printSucceededDate) {
    statuses.push(<span className="text-success">Print Completed</span>);
  } else if (printFailedDate) {
    statuses.push(<span className="text-danger">Print Failed</span>);
  }

  return statuses.length > 0 ? (
    statuses.reduce((result, item) => (
      <>
        {result} & {item}
      </>
    ))
  ) : (
    <span>Unknown</span>
  );
}
